import React, { Component, PropTypes } from 'react';
import ListSelector from 'components/ListSelector';
import { mixin, RefluxMixin } from 'Util';
import CourseStore from 'stores/Course';
import BundleStore from 'stores/Bundle';
import CourseActions from 'actions/Course';
import BundleActions from 'actions/Bundle';

export default class CourseSelector extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(BundleStore);
  }

  componentDidMount() {
    BundleActions.read();
  }

  getSelected() {
    return this.refs.list.getSelected();
  }

  render() {
   
    return (
      <ListSelector
        ref="list"
        searchHint={this.context.getIntlMessage('bundle.choose')}
        {...this.props}
        items={this.state.list}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/BundleSelector.js